import Controller, { OnAfterFetch, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import BaseController from '../../BaseController';

interface TermsOfUseData {
  dsTermo: string;
  nrSequencia: number;
}

@Controller({ component: 'modal-terms-of-use', fragment: 'terms-of-use-detail' })
class TermsOfUseDetailsController extends BaseController {

  termsOfUseResponse!: TermsOfUseData;

  @OnMount({ target: 'panel-terms-of-use' })
  onMountPanel(): void {
    const { nrSequencia } = this.historyService.getCurrentRouteParams();
    this.context.set({
      nrSequencia: nrSequencia
    });
  }

  @OnAfterFetch({ target: 'fetch-terms-of-use' })
  onAfterFetchTerms(e: FetchEvent): void {
    this.termsOfUseResponse = e.data as TermsOfUseData;
  }

  @OnClose({ target: 'modal-terms-of-use' })
  onCloseModal(): void {
    this.historyService.back();
  }

}

export default TermsOfUseDetailsController;